var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{staticClass:"elevation-0",attrs:{"headers":_vm.headers,"items":_vm.desserts,"items-per-page":5},scopedSlots:_vm._u([{key:"item.progreso",fn:function({ item }){return [_c('div',[_c('v-progress-linear',{attrs:{"color":"#00CCCA","value":item.progreso}}),_vm._v(" "+_vm._s(item.progreso)+"% ")],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }